import React, { CSSProperties } from 'react';

interface LogoProps {
  style?: Pick<
    CSSProperties,
    'width' | 'height' | 'fill' | 'color' | 'verticalAlign'
  >;
}

const Order = ({ style = {} }: LogoProps) => (
  <svg style={{ width: 30, height: 30, ...style }} viewBox="0 0 28 28">
    <rect
      width="28"
      height="28"
      rx="14"
      fill="currentColor"
      fillOpacity="0.2"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill="currentColor"
      d="M16.5 9.5C16.5 8.11929 15.3807 7 14 7C12.6193 7 11.5 8.11929 11.5 9.5V10H16.5V9.5ZM17.5 9.5V10H21V20C21 21.1046 20.1046 22 19 22H9C7.89543 22 7 21.1046 7 20V10H10.5V9.5C10.5 7.567 12.067 6 14 6C15.933 6 17.5 7.567 17.5 9.5ZM16.8402 14.9311C17.0533 14.7181 17.0533 14.3728 16.8402 14.1598C16.6272 13.9467 16.2819 13.9467 16.0688 14.1598L13.1818 17.0468L11.9311 15.7961C11.7181 15.5831 11.3728 15.5831 11.1598 15.7961C10.9467 16.0091 10.9467 16.3545 11.1598 16.5675L12.7961 18.2039C12.8984 18.3062 13.0372 18.3636 13.1818 18.3636C13.3265 18.3636 13.4652 18.3062 13.5675 18.2039L16.8402 14.9311Z"
    />
  </svg>
);

const OrderActive = ({ style = {} }: LogoProps) => (
  <svg style={{ width: 30, height: 30, ...style }} viewBox="0 0 28 28">
    <rect width="28" height="28" rx="14" fill="currentColor" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill="white"
      d="M16.5 9.5C16.5 8.11929 15.3807 7 14 7C12.6193 7 11.5 8.11929 11.5 9.5V10H16.5V9.5ZM17.5 9.5V10H21V20C21 21.1046 20.1046 22 19 22H9C7.89543 22 7 21.1046 7 20V10H10.5V9.5C10.5 7.567 12.067 6 14 6C15.933 6 17.5 7.567 17.5 9.5ZM16.8402 14.9311C17.0533 14.7181 17.0533 14.3728 16.8402 14.1598C16.6272 13.9467 16.2819 13.9467 16.0688 14.1598L13.1818 17.0468L11.9311 15.7961C11.7181 15.5831 11.3728 15.5831 11.1598 15.7961C10.9467 16.0091 10.9467 16.3545 11.1598 16.5675L12.7961 18.2039C12.8984 18.3062 13.0372 18.3636 13.1818 18.3636C13.3265 18.3636 13.4652 18.3062 13.5675 18.2039L16.8402 14.9311Z"
    />
  </svg>
);

const Store = ({ style = {} }: LogoProps) => (
  <svg style={{ width: 30, height: 30, ...style }} viewBox="0.7 0.5 31 30">
    <rect
      x="0.666748"
      width="31"
      height="31"
      rx="15"
      fill="currentColor"
      fillOpacity="0.2"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill="currentColor"
      d="M10.4668 7.7998C9.36223 7.7998 8.4668 8.69524 8.4668 9.79981V20.1998C8.4668 21.3044 9.36223 22.1998 10.4668 22.1998H15.6666V15.9998C15.6666 15.4475 16.1143 14.9998 16.6666 14.9998H19.5266C20.0789 14.9998 20.5266 15.4475 20.5266 15.9998V22.1998H20.8668C21.9714 22.1998 22.8668 21.3044 22.8668 20.1998V9.7998C22.8668 8.69524 21.9714 7.7998 20.8668 7.7998H10.4668ZM10.7166 9.9498C10.1643 9.9498 9.71662 10.3975 9.71662 10.9498C9.71662 11.5021 10.1643 11.9498 10.7166 11.9498L20.6166 11.9498C21.1689 11.9498 21.6166 11.5021 21.6166 10.9498C21.6166 10.3975 21.1689 9.9498 20.6166 9.9498H10.7166ZM9.99662 15.9998C9.99662 15.4475 10.4443 14.9998 10.9966 14.9998H12.2366C12.7889 14.9998 13.2366 15.4475 13.2366 15.9998V17.2398C13.2366 17.7921 12.7889 18.2398 12.2366 18.2398H10.9966C10.4443 18.2398 9.99662 17.7921 9.99662 17.2398V15.9998Z"
    />
  </svg>
);

const StoreActive = ({ style = {} }: LogoProps) => (
  <svg style={{ width: 30, height: 30, ...style }} viewBox="0.7 0.5 31 30">
    <rect x="0.666748" width="31" height="31" rx="15" fill="currentColor" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.4668 7.7998C9.36223 7.7998 8.4668 8.69524 8.4668 9.79981V20.1998C8.4668 21.3044 9.36223 22.1998 10.4668 22.1998H15.6666V15.9998C15.6666 15.4475 16.1143 14.9998 16.6666 14.9998H19.5266C20.0789 14.9998 20.5266 15.4475 20.5266 15.9998V22.1998H20.8668C21.9714 22.1998 22.8668 21.3044 22.8668 20.1998V9.7998C22.8668 8.69524 21.9714 7.7998 20.8668 7.7998H10.4668ZM10.7166 9.9498C10.1643 9.9498 9.71662 10.3975 9.71662 10.9498C9.71662 11.5021 10.1643 11.9498 10.7166 11.9498L20.6166 11.9498C21.1689 11.9498 21.6166 11.5021 21.6166 10.9498C21.6166 10.3975 21.1689 9.9498 20.6166 9.9498H10.7166ZM9.99662 15.9998C9.99662 15.4475 10.4443 14.9998 10.9966 14.9998H12.2366C12.7889 14.9998 13.2366 15.4475 13.2366 15.9998V17.2398C13.2366 17.7921 12.7889 18.2398 12.2366 18.2398H10.9966C10.4443 18.2398 9.99662 17.7921 9.99662 17.2398V15.9998Z"
      fill="white"
    />
  </svg>
);

const Car = ({ style = {} }: LogoProps) => (
  <svg style={{ width: 30, height: 30, ...style }} viewBox="0.3 0.5 31 30">
    <rect
      x="0.333252"
      width="31"
      height="31"
      rx="15"
      fill="currentColor"
      fillOpacity="0.2"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill="currentColor"
      d="M10.3649 9.08241C10.4244 8.86504 10.6219 8.71429 10.8472 8.71429H19.6702C19.8896 8.71429 20.0833 8.8572 20.148 9.06675L21.2509 12.6382C21.3503 12.9598 21.1098 13.2857 20.7732 13.2857H9.87068C9.54086 13.2857 9.30139 12.972 9.38838 12.6538L10.3649 9.08241ZM10.1923 7C9.76664 7 9.38385 7.31296 9.22576 7.79025L7.40873 13.276C7.36808 13.3987 7.3446 13.523 7.33649 13.6458C7.33643 13.6466 7.33573 13.6473 7.33487 13.6473C7.33398 13.6473 7.33325 13.648 7.33325 13.6489V13.744V19.9937V20.2355V21.5026C7.33325 21.8892 7.64665 22.2026 8.03325 22.2026H9.45678C9.84338 22.2026 10.1568 21.8892 10.1568 21.5026V21.2355C10.1568 20.6832 10.6045 20.2355 11.1568 20.2355H19.5098C20.0621 20.2355 20.5098 20.6832 20.5098 21.2355V21.4187C20.5098 21.8053 20.8232 22.1187 21.2098 22.1187H22.6333C23.0199 22.1187 23.3333 21.8053 23.3333 21.4187V19.9097C23.3333 19.9058 23.3333 19.9019 23.3333 19.898V13.7455V13.7424V13.6489C23.3333 13.648 23.3325 13.6473 23.3316 13.6473C23.3308 13.6473 23.3301 13.6466 23.33 13.6458C23.3219 13.523 23.2984 13.3987 23.2578 13.276L21.4407 7.79025C21.2827 7.31297 20.8999 7 20.4742 7H10.1923ZM9.21568 16.0584C9.21568 15.5061 9.6634 15.0584 10.2157 15.0584H11.0392C11.5915 15.0584 12.0392 15.5061 12.0392 16.0584V16.9673C12.0392 17.5196 11.5915 17.9673 11.0392 17.9673H10.2157C9.6634 17.9673 9.21568 17.5196 9.21568 16.9673V16.0584ZM19.6274 15.0584C19.0751 15.0584 18.6274 15.5061 18.6274 16.0584V16.9673C18.6274 17.5196 19.0751 17.9673 19.6274 17.9673H20.4509C21.0032 17.9673 21.4509 17.5196 21.4509 16.9673V16.0584C21.4509 15.5061 21.0032 15.0584 20.4509 15.0584H19.6274Z"
    />
  </svg>
);

const CarActive = ({ style = {} }: LogoProps) => (
  <svg style={{ width: 30, height: 30, ...style }} viewBox="0.3 0.5 31 30">
    <rect x="0.333252" width="31" height="31" rx="15" fill="currentColor" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.3649 9.08241C10.4244 8.86504 10.6219 8.71429 10.8472 8.71429H19.6702C19.8896 8.71429 20.0833 8.8572 20.148 9.06675L21.2509 12.6382C21.3503 12.9598 21.1098 13.2857 20.7732 13.2857H9.87068C9.54086 13.2857 9.30139 12.972 9.38838 12.6538L10.3649 9.08241ZM10.1923 7C9.76664 7 9.38385 7.31296 9.22576 7.79025L7.40873 13.276C7.36808 13.3987 7.3446 13.523 7.33649 13.6458C7.33643 13.6466 7.33573 13.6473 7.33487 13.6473C7.33398 13.6473 7.33325 13.648 7.33325 13.6489V13.744V19.9937V20.2355V21.5026C7.33325 21.8892 7.64665 22.2026 8.03325 22.2026H9.45678C9.84338 22.2026 10.1568 21.8892 10.1568 21.5026V21.2355C10.1568 20.6832 10.6045 20.2355 11.1568 20.2355H19.5098C20.0621 20.2355 20.5098 20.6832 20.5098 21.2355V21.4187C20.5098 21.8053 20.8232 22.1187 21.2098 22.1187H22.6333C23.0199 22.1187 23.3333 21.8053 23.3333 21.4187V19.9097C23.3333 19.9058 23.3333 19.9019 23.3333 19.898V13.7455V13.7424V13.6489C23.3333 13.648 23.3325 13.6473 23.3316 13.6473C23.3308 13.6473 23.3301 13.6466 23.33 13.6458C23.3219 13.523 23.2984 13.3987 23.2578 13.276L21.4407 7.79025C21.2827 7.31297 20.8999 7 20.4742 7H10.1923ZM9.21568 16.0584C9.21568 15.5061 9.6634 15.0584 10.2157 15.0584H11.0392C11.5915 15.0584 12.0392 15.5061 12.0392 16.0584V16.9673C12.0392 17.5196 11.5915 17.9673 11.0392 17.9673H10.2157C9.6634 17.9673 9.21568 17.5196 9.21568 16.9673V16.0584ZM19.6274 15.0584C19.0751 15.0584 18.6274 15.5061 18.6274 16.0584V16.9673C18.6274 17.5196 19.0751 17.9673 19.6274 17.9673H20.4509C21.0032 17.9673 21.4509 17.5196 21.4509 16.9673V16.0584C21.4509 15.5061 21.0032 15.0584 20.4509 15.0584H19.6274Z"
      fill="white"
    />
  </svg>
);

const House = ({ style = {} }: LogoProps) => (
  <svg style={{ width: 30, height: 30, ...style }} viewBox="0 0 30 30">
    <rect
      width="30"
      height="30"
      rx="15"
      fill="currentColor"
      fillOpacity="0.2"
    />
    <path
      fill="currentColor"
      d="M17.9699 18.4502C18.4699 18.4502 18.4699 18.4499 18.4699 18.4497L18.4699 18.4491L18.4699 18.4477L18.4699 18.4441L18.4698 18.4336C18.4697 18.4252 18.4694 18.4139 18.469 18.4C18.468 18.3722 18.4663 18.3337 18.4629 18.286C18.4562 18.1908 18.4429 18.0581 18.4169 17.9C18.3651 17.5864 18.2607 17.1605 18.0468 16.7284C17.832 16.2945 17.5017 15.8446 16.9963 15.5042C16.4874 15.1616 15.831 14.9502 15 14.9502C14.1689 14.9502 13.5125 15.1616 13.0036 15.5042C12.4982 15.8446 12.1679 16.2945 11.9531 16.7284C11.7392 17.1605 11.6348 17.5864 11.583 17.9C11.557 18.0581 11.5437 18.1908 11.537 18.286C11.5336 18.3337 11.5319 18.3722 11.5309 18.4C11.5308 18.406 11.5306 18.4115 11.5305 18.4165C11.5303 18.4231 11.5302 18.4288 11.5301 18.4336L11.53 18.4441L11.53 18.4477L11.53 18.4491L11.53 18.4497C11.53 18.4499 11.53 18.4502 12.03 18.4502H11.53V23.0502H10.07C9.24152 23.0502 8.56995 22.3786 8.56995 21.5502V15.6502C8.56995 15.2636 8.25655 14.9502 7.86995 14.9502H6.962C6.49435 14.9502 6.28265 14.3655 6.64191 14.0661L14.6799 7.36779C14.8653 7.21327 15.1346 7.21327 15.32 7.36779L23.358 14.0661C23.7172 14.3654 23.5056 14.9502 23.0378 14.9502H22.1292C21.7399 14.9502 21.43 15.2662 21.43 15.6502V21.5502C21.43 22.3786 20.7584 23.0502 19.9299 23.0502H18.4699V18.4502H17.9699Z"
    />
  </svg>
);

const HouseActive = ({ style = {} }: LogoProps) => (
  <svg style={{ width: 30, height: 30, ...style }} viewBox="0 0 30 30">
    <rect width="30" height="30" rx="15" fill="currentColor" />
    <path
      d="M17.9699 18.4502C18.2199 18.4502 18.2199 18.4501 18.2199 18.4499L18.2199 18.4496L18.2199 18.4487L18.2199 18.4461L18.2198 18.4376L18.2191 18.4083C18.2183 18.3834 18.2167 18.348 18.2135 18.3037C18.2073 18.215 18.1948 18.0901 18.1702 17.9407C18.1211 17.6433 18.0225 17.2428 17.8228 16.8393C17.6225 16.4348 17.3182 16.0224 16.8566 15.7116C16.3934 15.3996 15.7867 15.2002 15 15.2002C14.2132 15.2002 13.6065 15.3996 13.1433 15.7116C12.6817 16.0224 12.3774 16.4348 12.1771 16.8393C11.9774 17.2428 11.8788 17.6433 11.8297 17.9407C11.8051 18.0901 11.7926 18.215 11.7864 18.3037C11.7832 18.348 11.7816 18.3834 11.7808 18.4083L11.7801 18.4376L11.78 18.4461L11.78 18.4487L11.78 18.4496L11.78 18.4499C11.78 18.4501 11.78 18.4502 12.03 18.4502H11.78V23.2502C11.78 23.2778 11.7576 23.3002 11.73 23.3002H10.07C9.10345 23.3002 8.31995 22.5167 8.31995 21.5502V15.7502C8.31995 15.4464 8.07371 15.2002 7.76995 15.2002H6.962C6.26053 15.2002 5.94298 14.3231 6.48186 13.874L14.5198 7.17574C14.7979 6.94396 15.202 6.94396 15.4801 7.17574L23.518 13.874C24.0569 14.3231 23.7393 15.2002 23.0378 15.2002H22.2291C21.9243 15.2002 21.68 15.4474 21.68 15.7502V21.5502C21.68 22.5167 20.8964 23.3002 19.9299 23.3002H18.2699C18.2423 23.3002 18.2199 23.2778 18.2199 23.2502V18.4502H17.9699Z"
      fill="white"
    />
  </svg>
);

const Error = ({ style = {} }: LogoProps) => (
  <svg style={{ width: 24, height: 16, ...style }} viewBox="0 0 24 16">
    <path
      fill="currentColor"
      d="M12.9815 1.56642C12.5376 0.811193 11.4655 0.811193 11.0216 1.56642L4.16463 13.2331C3.70759 14.0107 4.25628 15 5.14459 15H18.8585C19.7468 15 20.2955 14.0107 19.8385 13.2331L12.9815 1.56642ZM12 5C12.5354 5 12.9538 5.46228 12.9005 5.99504L12.5498 9.50248C12.5215 9.78492 12.2838 10 12 10C11.7162 10 11.4785 9.78492 11.4502 9.50248L11.0995 5.99504C11.0462 5.46229 11.4646 5 12 5ZM12.0015 11C12.5538 11 13.0015 11.4477 13.0015 12C13.0015 12.5523 12.5538 13 12.0015 13C11.4493 13 11.0015 12.5523 11.0015 12C11.0015 11.4477 11.4493 11 12.0015 11Z"
    />
  </svg>
);

const Clock = ({ style = {} }: LogoProps) => (
  <svg style={{ width: 14, height: 14, ...style }} viewBox="0 0 14 14">
    <path
      d="M7 3.0625C7 2.82088 6.80412 2.625 6.5625 2.625C6.32088 2.625 6.125 2.82088 6.125 3.0625V7.875C6.125 8.032 6.20913 8.17696 6.34544 8.25486L9.40794 10.0049C9.61773 10.1247 9.88498 10.0519 10.0049 9.84206C10.1247 9.63227 10.0518 9.36502 9.84206 9.24514L7 7.62111V3.0625Z"
      fill="currentColor"
    />
    <path
      d="M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14ZM13.125 7C13.125 10.3827 10.3827 13.125 7 13.125C3.61726 13.125 0.875 10.3827 0.875 7C0.875 3.61726 3.61726 0.875 7 0.875C10.3827 0.875 13.125 3.61726 13.125 7Z"
      fill="currentColor"
    />
  </svg>
);

const CheckMark = ({ style = {} }: LogoProps) => (
  <svg
    style={{ width: 31, height: 30, ...style }}
    viewBox="0 0 31 30"
    fill="currentColor"
  >
    <rect x="0.5" width="30" height="30" rx="15" fillOpacity="0.2" />
    <path d="M22.4324 9.89761C22.9054 9.44038 23.6723 9.44038 24.1453 9.89761C24.6124 10.3492 24.6182 11.078 24.1625 11.5364L14.4859 22.4489C14.4766 22.4601 14.4666 22.4708 14.4561 22.481C13.9831 22.9383 13.2162 22.9383 12.7433 22.481L6.85474 16.7886C6.38175 16.3314 6.38175 15.59 6.85474 15.1328C7.32772 14.6756 8.09458 14.6756 8.56756 15.1328L13.5632 19.9621L22.4003 9.93263C22.4103 9.92035 22.421 9.90865 22.4324 9.89761Z" />
  </svg>
);

const CheckMarkActive = ({ style = {} }: LogoProps) => (
  <svg
    style={{ width: 31, height: 30, ...style }}
    viewBox="0 0 31 30"
    fill="currentColor"
  >
    <rect x="0.5" width="30" height="30" rx="15" fill="currentColor" />
    <path
      d="M22.4324 9.89761C22.9054 9.44038 23.6723 9.44038 24.1453 9.89761C24.6124 10.3492 24.6182 11.078 24.1625 11.5364L14.4859 22.4489C14.4766 22.4601 14.4666 22.4708 14.4561 22.481C13.9831 22.9383 13.2162 22.9383 12.7433 22.481L6.85474 16.7886C6.38175 16.3314 6.38175 15.59 6.85474 15.1328C7.32772 14.6756 8.09458 14.6756 8.56756 15.1328L13.5632 19.9621L22.4003 9.93263C22.4103 9.92035 22.421 9.90865 22.4324 9.89761Z"
      fill="white"
    />
  </svg>
);

const Scheduled = ({ style = {} }: LogoProps) => (
  <svg
    style={{ width: 28, height: 28, ...style }}
    viewBox="0 0 28 28"
    fill="currentColor"
  >
    <rect width="28" height="28" rx="14" />
    <path
      d="M22 14C22 18.4183 18.4183 22 14 22C9.58172 22 6 18.4183 6 14C6 9.58172 9.58172 6 14 6C18.4183 6 22 9.58172 22 14ZM14 9.5C14 9.22386 13.7761 9 13.5 9C13.2239 9 13 9.22386 13 9.5V15C13 15.1794 13.0961 15.3451 13.2519 15.4341L16.7519 17.4341C16.9917 17.5711 17.2971 17.4878 17.4341 17.2481C17.5711 17.0083 17.4878 16.7029 17.2481 16.5659L14 14.7098V9.5Z"
      fill="white"
    />
  </svg>
);

export {
  Order,
  OrderActive,
  Store,
  StoreActive,
  Car,
  CarActive,
  House,
  HouseActive,
  Error,
  Clock,
  CheckMark,
  CheckMarkActive,
  Scheduled,
};
